
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as index0vekUTRDdGGGj3YETfTyA1_Esxwajwpc4x6zuARjnicMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/index.vue?macro=true";
import { default as alumniXJ_458btlgCG567ZBCqRXBSUQsK_Wli1E78pto4VYEpW0Meta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/alumni.vue?macro=true";
import { default as searchD1AmJ1iYooLTW3YutBl_45zlh7BYM7grCM_45jmSLVAU0osMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/search.vue?macro=true";
import { default as peopleaj6PNOnZ_8kFSEE_aiFjMlidUtp8nogNY7A_h5pf6PQMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/other/people.vue?macro=true";
import { default as _91slug_93dm7yGuxd8a01evK4noGBts8sKCOeBewwYxUZdTEyiCgMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/notice/[slug].vue?macro=true";
import { default as indexg0J5ESgLuH8yMcPAV7cx7QLP_45V1JKFGBpv97LEK_45SEgMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/program/index.vue?macro=true";
import { default as indexkvrl_451m_454PDU_45Ic_45AL6rXJftGTGhJyToUa2cJ38gdz4Meta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/studium/index.vue?macro=true";
import { default as indexe5WosCyAvNczXXZ5gu9DmvN5bmZye2zhyDFqYr3oCu0Meta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/akademie/index.vue?macro=true";
import { default as _91slug_93bdyNqW4efFuNzF6q_9hi60gG_wKr_45zkO0dS2Bw8dZzYMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/article/[slug].vue?macro=true";
import { default as _91slug_93B0vrRpkbx_sTf0g_c8QyPZkP5bYFW_45yDklLOzfLkNSEMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/student/[slug].vue?macro=true";
import { default as alumni_45drop_45outHBfNxE8WeflbbTOtQPa6ehN0QdYSAtW7W_ou_455vmHU4Meta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/alumni-drop-out.vue?macro=true";
import { default as _91slug_93DKZjGBN9AGMOKvnF11GV2ZBQ_45U2XsdK74GJFrMoZJcgMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/employee/[slug].vue?macro=true";
import { default as _91slug_93jUvfqFlI0ZyKGQO6yP180jaTpsMQs03nF8yEEExbF5EMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/department/[slug].vue?macro=true";
import { default as publicationcNcD88mczuqemL6r1glIYo090MR3s7gKnMaUiaOpgv0Meta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/other/publication.vue?macro=true";
import { default as _91category_93y6KBQv9_SfUHEw40TZGbgrud_weLY7Z1K1dhnSQA9k8Meta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/program/[category].vue?macro=true";
import { default as _91slug_93XY949ZT4PZvqgW61tPTwovW7oSB4Yyp4KljmBHTuNvQMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/publication/[slug].vue?macro=true";
import { default as _91item_93UTwl2myZ65He0LoYxjOeAOTd68P1w1dBsr9Q7mV79z8Meta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/program/[id]/[item].vue?macro=true";
import { default as _91item_93YvXSADBrgkuV3y3L2HUhtpddtmh07caybfQIzH8qFvQMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/studium/[id]/[item].vue?macro=true";
import { default as _91item_93WuceCqckRcUwhOb0EozoEkhO9kTNPTYP0OHREuS4UrYMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/akademie/[id]/[item].vue?macro=true";
import { default as component_45stub_45NIZsDtFbnCL2uYe2a9k2YQvdlQuzQOgkb7nVnuIXgIMeta } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub_45NIZsDtFbnCL2uYe2a9k2YQvdlQuzQOgkb7nVnuIXgI } from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___en",
    path: "/en",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/index.vue")
  },
  {
    name: "index___cs",
    path: "/",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/index.vue")
  },
  {
    name: "alumni___en",
    path: "/en/alumni",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/alumni.vue")
  },
  {
    name: "alumni___cs",
    path: "/alumni",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/alumni.vue")
  },
  {
    name: "search___en",
    path: "/en/search",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/search.vue")
  },
  {
    name: "search___cs",
    path: "/hledej",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/search.vue")
  },
  {
    name: "other-people___en",
    path: "/en/other/people",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/other/people.vue")
  },
  {
    name: "other-people___cs",
    path: "/ostatni/lide",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/other/people.vue")
  },
  {
    name: "notice-slug___en",
    path: "/en/notice/:slug()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/notice/[slug].vue")
  },
  {
    name: "notice-slug___cs",
    path: "/aktualita/:slug()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/notice/[slug].vue")
  },
  {
    name: "program___en",
    path: "/en/program",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/program/index.vue")
  },
  {
    name: "program___cs",
    path: "/program",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/program/index.vue")
  },
  {
    name: "studium___en",
    path: "/en/study",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/studium/index.vue")
  },
  {
    name: "studium___cs",
    path: "/studium",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/studium/index.vue")
  },
  {
    name: "akademie___en",
    path: "/en/academy",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/akademie/index.vue")
  },
  {
    name: "akademie___cs",
    path: "/akademie",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/akademie/index.vue")
  },
  {
    name: "article-slug___en",
    path: "/en/article/:slug()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/article/[slug].vue")
  },
  {
    name: "article-slug___cs",
    path: "/stranka/:slug()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/article/[slug].vue")
  },
  {
    name: "student-slug___en",
    path: "/en/student/:slug()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/student/[slug].vue")
  },
  {
    name: "student-slug___cs",
    path: "/student/:slug()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/student/[slug].vue")
  },
  {
    name: "alumni-drop-out___en",
    path: "/en/alumni-drop-out",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/alumni-drop-out.vue")
  },
  {
    name: "alumni-drop-out___cs",
    path: "/alumni-drop-out",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/alumni-drop-out.vue")
  },
  {
    name: "employee-slug___en",
    path: "/en/employee/:slug()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/employee/[slug].vue")
  },
  {
    name: "employee-slug___cs",
    path: "/zamestnanec/:slug()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/employee/[slug].vue")
  },
  {
    name: "department-slug___en",
    path: "/en/department/:slug()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/department/[slug].vue")
  },
  {
    name: "department-slug___cs",
    path: "/oddeleni/:slug()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/department/[slug].vue")
  },
  {
    name: "other-publication___en",
    path: "/en/other/publication",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/other/publication.vue")
  },
  {
    name: "other-publication___cs",
    path: "/ostatni/publikace",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/other/publication.vue")
  },
  {
    name: "program-category___en",
    path: "/en/program/:category()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/program/[category].vue")
  },
  {
    name: "program-category___cs",
    path: "/program/:category()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/program/[category].vue")
  },
  {
    name: "publication-slug___en",
    path: "/en/publication/:slug()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/publication/[slug].vue")
  },
  {
    name: "publication-slug___cs",
    path: "/publikace/:slug()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/publication/[slug].vue")
  },
  {
    name: "program-id-item___en",
    path: "/en/program/:id()/:item()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/program/[id]/[item].vue")
  },
  {
    name: "program-id-item___cs",
    path: "/program/:id()/:item()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/program/[id]/[item].vue")
  },
  {
    name: "studium-id-item___en",
    path: "/en/study/:id()/:item()",
    meta: _91item_93YvXSADBrgkuV3y3L2HUhtpddtmh07caybfQIzH8qFvQMeta || {},
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/studium/[id]/[item].vue")
  },
  {
    name: "studium-id-item___cs",
    path: "/studium/:id()/:item()",
    meta: _91item_93YvXSADBrgkuV3y3L2HUhtpddtmh07caybfQIzH8qFvQMeta || {},
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/studium/[id]/[item].vue")
  },
  {
    name: "akademie-id-item___en",
    path: "/en/academy/:id()/:item()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/akademie/[id]/[item].vue")
  },
  {
    name: "akademie-id-item___cs",
    path: "/akademie/:id()/:item()",
    component: () => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/pages/akademie/[id]/[item].vue")
  },
  {
    name: component_45stub_45NIZsDtFbnCL2uYe2a9k2YQvdlQuzQOgkb7nVnuIXgIMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stub_45NIZsDtFbnCL2uYe2a9k2YQvdlQuzQOgkb7nVnuIXgI
  },
  {
    name: component_45stub_45NIZsDtFbnCL2uYe2a9k2YQvdlQuzQOgkb7nVnuIXgIMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub_45NIZsDtFbnCL2uYe2a9k2YQvdlQuzQOgkb7nVnuIXgI
  }
]